import "./filterControls.css";

// Pill-style single choice for short option lists (two to five options).
// Quicker to scan and tap than a dropdown, and the current value is always
// visible. Clicking the selected chip clears it (unless allowClear is off).
// onChange receives the option object ({label, value}) or "" when cleared,
// the same contract as FilterSelect's onChange.
const ChoiceChips = ({ options = [], value, onChange, allowClear = true, ariaLabel }) => {
  const current = value === null || value === undefined ? "" : String(value);
  return (
    <div role="radiogroup" aria-label={ariaLabel} className="choice-chips">
      {options.map((option) => {
        const selected = current !== "" && String(option.value) === current;
        return (
          <button
            key={String(option.value)}
            type="button"
            role="radio"
            aria-checked={selected}
            className={`choice-chip${selected ? " is-selected" : ""}`}
            onClick={() => onChange(selected && allowClear ? "" : option)}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default ChoiceChips;
